import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { createApi } from "services/api";

import rootReducer from "./reducers";
import rootSaga from "./sagas";
import { middleware as thunkMiddleware } from "redux-saga-thunk";

const services = { api: createApi() };
const sagaMiddleware = createSagaMiddleware();

// mount it on the Store
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunkMiddleware, sagaMiddleware))
);

sagaMiddleware.run(rootSaga, services);

export default store;



// WEBPACK FOOTER //
// ./src/configureStore.js